import { BadgeM } from "@common/components/badge/BadgeM"
import FilledButtonM from "@common/components/button/FilledButtonM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { IS_WEB } from "@common/utils/mobileUtils"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { setTodoActivities } from "@data/redux/actions/data"
import { setIsLiveModeEnabled } from "@data/redux/actions/liveMode"
import { authService } from "@data/services/authService"
import { useNavigation } from "@react-navigation/native"
import React, { useEffect, useMemo, useRef, useState } from "react"
import { TouchableOpacity, View } from "react-native"
import { StatusBar } from "@common/systemBars/StatusBar"
import {
    FlatList,
    RefreshControl,
    ScrollView,
} from "react-native-gesture-handler"
import { ActivityIndicator, IconButton } from "react-native-paper"
import { connect } from "react-redux"
import { useCurrentActivity } from "../../../common/hooks/useCurrentActivity"
import useLaunchActivity from "../../../common/hooks/useLaunchActivity"
import { setCurrentActivity } from "../../../data/redux/actions/activity"
import { hasRole } from "../../../data/utility/ability"
import { getTodaysFinishedActivities } from "../../../data/utility/dataUtils"
import RealizationsListItem from "../../organize/list/RealizationsListItem"

const TodoListModalItems = (props) => {
    // ** Component props
    const { student, todoList = [], nav, closeModal = () => {}, route } = props

    const { getCurrentActivity } = useCurrentActivity()
    const currentActivity = getCurrentActivity()

    const user = student ? student : props.user

    const todos = todoList ?? user?.todo_activities

    const finishedActivities = useMemo(
        () => getTodaysFinishedActivities(user),
        [user]
    )

    const [showFinishedActivitiesList, setShowFinishedActivitiesList] =
        useState(finishedActivities?.length > 0)

    const navigation = nav ?? useNavigation()

    const request = student
        ? props.getStudentRequest
        : props.getUserRequest ||
          props.getSessionsRequest ||
          props.getCallRequest

    const getUserService = authService.getUser
    const getUserParams = {}

    useEffect(() => {
        props.apiRequest(getUserService, getUserParams)
    }, [])

    const flatListRef = useRef()

    const launchActivity = useLaunchActivity(navigation, route)

    const renderItem = ({ item, isActive }) => {
        return (
            <RealizationsListItem
                key={item.id}
                activity={item}
                custom
                student={student}
                todo={true}
                disabled={isActive}
                noOptions={true}
                noDragAndDrop={true}
                style={{
                    opacity: 0.8,
                    width: "95%",
                    alignSelf: "center",
                }}
                nav={navigation}
                onPressCallback={closeModal}
                onPress={() => {
                    if (hasRole(props.user, "student")) {
                        if (currentActivity?.activityData?.id !== item?.id) {
                            launchActivity(item, route)
                        }
                        closeModal()
                    }
                }}
                currentActivityId={currentActivity?.activityData?.id}
                highlighted={item.id == currentActivity?.activityData?.id}
            />
        )
    }

    return (
        <ScrollView
            showsVerticalScrollIndicator={true}
            style={{
                flex: 1,
                alignSelf: "center",
                width: "100%",
            }}
            contentContainerStyle={{
                width: "100%",
                alignItems: "center",
            }}
        >
            <View style={{ width: "100%" }}>
                <View
                    style={{
                        flexDirection: "row",
                        alignItems: "center",
                        alignSelf: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        borderColor: theme.colors.lightMore,
                        paddingBottom: 15,
                        paddingHorizontal: 10,
                    }}
                >
                    <View
                        style={{
                            flexDirection: "row",
                            alignItems: "center",
                        }}
                    >
                        {!todoList && (
                            <>
                                {request && IS_WEB ? (
                                    <ActivityIndicator
                                        color={theme.colors.primary}
                                        size={"small"}
                                    />
                                ) : (
                                    <IconButton
                                        onPress={() => {
                                            props.apiRequest(
                                                getUserService,
                                                getUserParams
                                            )
                                        }}
                                        iconColor={theme.colors.primary}
                                        containerColor={
                                            theme.colors.transparent
                                        }
                                        disabled={request}
                                        icon={"sync-alt"}
                                        size={20}
                                    />
                                )}
                            </>
                        )}
                    </View>
                </View>
                {(finishedActivities?.length > 0 || user?.xp > 0) && (
                    <View>
                        <View
                            style={{
                                backgroundColor: theme.colors.lighter,
                                marginHorizontal: 10,
                                borderRadius: 10,
                                width: "100%",
                                alignSelf: "center",
                            }}
                        >
                            {(finishedActivities?.length > 0 ||
                                user?.xp > 0) && (
                                <TouchableOpacity
                                    onPress={() => {
                                        setShowFinishedActivitiesList(
                                            !showFinishedActivitiesList
                                        )
                                    }}
                                    style={{
                                        flexDirection: "row",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        paddingHorizontal: 8,
                                        paddingVertical: 8,
                                        borderRadius: 6,
                                        marginRight: 5,
                                        marginLeft: 5,
                                        marginTop: 5,
                                        marginBottom: 5,
                                    }}
                                >
                                    <View
                                        style={{
                                            flexDirection: "row",
                                            alignItems: "center",
                                        }}
                                    >
                                        <TextM
                                            fontSize={12}
                                            color={theme.colors.grey}
                                            fontWeight="Bold"
                                        >
                                            FAITES
                                        </TextM>
                                        <BadgeM
                                            style={{
                                                backgroundColor:
                                                    theme.colors.lighter,
                                                color: theme.colors.grey,
                                                marginLeft: 5,
                                            }}
                                            count={finishedActivities?.length}
                                            size={16}
                                        />
                                    </View>
                                    <TextM
                                        fontSize={10}
                                        color={theme.colors.grey}
                                        fontWeight="Bold"
                                        style={{
                                            textDecorationLine: "underline",
                                        }}
                                    >
                                        {showFinishedActivitiesList
                                            ? "MASQUER"
                                            : "AFFICHER"}
                                    </TextM>
                                </TouchableOpacity>
                            )}
                            {showFinishedActivitiesList && (
                                <View
                                    style={{
                                        alignSelf: "center",
                                        width: "100%",
                                    }}
                                >
                                    {finishedActivities.map((activity) => (
                                        <RealizationsListItem
                                            key={activity.id}
                                            activity={activity}
                                            custom
                                            student={student}
                                            withGoBack
                                            style={{
                                                opacity: 0.8,
                                                width: "95%",
                                                alignSelf: "center",
                                            }}
                                            nav={navigation}
                                            onPressCallback={closeModal}
                                            currentActivityId={
                                                currentActivity?.activityData
                                                    ?.id
                                            }
                                            highlighted={
                                                activity.id ==
                                                currentActivity?.activityData
                                                    ?.id
                                            }
                                        />
                                    ))}

                                    {showFinishedActivitiesList && (
                                        <View style={{ width: "100%" }}>
                                            <FilledButtonM
                                                mode={"text"}
                                                color={theme.colors.primary}
                                                style={{
                                                    width: null,
                                                    marginBottom: 0,
                                                }}
                                                labelStyle={{
                                                    fontSize: 10,
                                                    height: 16,
                                                }}
                                                contentStyle={{
                                                    height: 30,
                                                }}
                                                onPress={() => {
                                                    closeModal()
                                                    navigation.push(
                                                        "realizations",
                                                        {
                                                            initialTabRealizations: true,
                                                            withGoBack: true,
                                                        }
                                                    )
                                                }}
                                                label={"Voir plus"}
                                            />
                                        </View>
                                    )}
                                </View>
                            )}
                        </View>
                        {todos?.length > 0 && (
                            <View
                                style={{
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    paddingHorizontal: 8,
                                    paddingVertical: 8,
                                    borderRadius: 6,
                                    marginRight: 15,
                                    marginLeft: 15,
                                    marginBottom: 5,
                                    borderColor: theme.colors.lighter,
                                    paddingTop: 20,
                                    marginTop: -5,
                                    width: "100%",
                                    alignSelf: "center",
                                }}
                            >
                                <View
                                    style={{
                                        flexDirection: "row",
                                        alignItems: "center",
                                        width: "100%",
                                    }}
                                >
                                    <TextM
                                        fontSize={12}
                                        color={theme.colors.primary}
                                        fontWeight="Bold"
                                    >
                                        À FAIRE
                                    </TextM>
                                    <BadgeM
                                        style={{
                                            backgroundColor:
                                                theme.colors.primaryLighter,
                                            color: theme.colors.primary,
                                            marginLeft: 5,
                                        }}
                                        count={todos?.length}
                                        size={16}
                                    />
                                </View>
                            </View>
                        )}
                    </View>
                )}
                {todos?.length > 0 ? (
                    <FlatList
                        data={todos}
                        scrollEnabled={false}
                        refreshControl={
                            <RefreshControl
                                onRefresh={() => {
                                    props.apiRequest(
                                        getUserService,
                                        getUserParams
                                    )
                                }}
                                refreshing={!!request}
                            />
                        }
                        ref={flatListRef}
                        renderItem={renderItem}
                    />
                ) : (
                    <TextM
                        fontSize={12}
                        color={theme.colors.grey}
                        fontWeight="Regular"
                        style={{
                            marginTop: 20,
                            textAlign: "center",
                        }}
                    >
                        Aucune activité à faire
                    </TextM>
                )}
            </View>

            <StatusBar
                style="dark"
                backgroundColor={theme.colors.white}
                translucent={false}
            />
        </ScrollView>
    )
}

const mapStateToProps = (state) => {
    return {
        activityTodoIndexesAsStudentRequest:
            state.api.activityTodoIndexesAsStudent?.request,
        activityTemplates: state.data.staticData?.activity_templates,
        user: state.data.currentUser?.object,
        schoolSubjects: state.data.staticData?.school_subjects,
        getUserRequest: state.api.getUser?.request,
        getStudentRequest: state.api.getStudent?.request,
        isLive: state.liveMode.isLiveModeEnabled,
        liveSessions: state.data.currentUser?.object?.live_sessions,
        liveSessionId: state.liveMode?.liveSessionId,
        currentLiveSession: state.data.currentUser?.object?.live_sessions?.find(
            (x) => x?.id === state.liveMode?.liveSessionId
        ),
        inCallUsers: state.liveMode?.inCallUsers,
        getLiveSessionSuccess: state.api.getLiveSession?.success,
        callPortal: state.liveMode?.callPortal,
        maxTodoActivities: state.data.staticData?.max_todo_activities,
        isLiveMode: state.liveMode.isLiveModeEnabled,
        getActivityRequest: state.api.getActivity?.request,
        getActivitySuccess: state.api.getActivity?.success,
        updatedActivityEventData: state.activity?.updatedActivityEventData,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    setTodoActivities,
    setIsLiveModeEnabled,
    setCurrentActivity,
}

export default connect(mapStateToProps, mapDispatchToProps)(TodoListModalItems)
